module.exports = __webpack_public_path__ + "img/header.e62590e.svg";